require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-victor-benavente.json") })
        }
      }, "path---blog-author-victor-benavente");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-victor-benavente!./.cache/json/blog-author-victor-benavente.json
// module id = 714
// module chunks = 231608221292675